import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import AboutMission from './components/AboutMission';
import LocationAdvantages from './components/LocationAdvantages';

export default function AboutPage() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        <AboutHero />
        <AboutMission />
        <LocationAdvantages />
        {/* CTA */}
        <section className="py-20 bg-white text-center">
          <div className="max-w-2xl mx-auto px-6">
            <h2 className="font-heading text-3xl lg:text-4xl font-bold text-navy-800 mb-4">
              Ready to Find Your Room?
            </h2>
            <p className="text-navy-700/65 text-base mb-8 leading-relaxed">
              Browse our current vacancies and secure your all-inclusive furnished room today.
            </p>
            <a
              href="https://rentals.galaxyhousing.com.au"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-navy-800 hover:bg-navy-700 text-white font-semibold text-sm px-8 py-4 rounded transition-colors cursor-pointer whitespace-nowrap"
            >
              View Available Rentals
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-external-link-line" />
              </div>
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
